export const initPhoneMask = () => {
	const phoneInputs = document.querySelectorAll(
		'.wpcf7 input[type="tel"]'
	);

	if (!phoneInputs.length) return;

	const getDigits = value => value.replace(/\D/g, '');

	const normalizeDigits = value => {
		let digits = getDigits(value);

		if (!digits) return '';

		if (digits[0] === '8') {
			digits = `7${digits.slice(1)}`;
		} else if (digits[0] !== '7') {
			digits = `7${digits}`;
		}

		return digits.slice(0, 11);
	};

	const formatPhone = value => {
		const digits = normalizeDigits(value);

		if (!digits) return '';

		let result = '+7';

		if (digits.length > 1) {
			result += ` (${digits.slice(1, 4)}`;
		}

		if (digits.length >= 4) {
			result += ')';
		}

		if (digits.length > 4) {
			result += ` ${digits.slice(4, 7)}`;
		}

		if (digits.length > 7) {
			result += `-${digits.slice(7, 9)}`;
		}

		if (digits.length > 9) {
			result += `-${digits.slice(9, 11)}`;
		}

		return result;
	};

	phoneInputs.forEach(input => {
		input.setAttribute('inputmode', 'tel');
		input.setAttribute('autocomplete', 'tel');
		input.setAttribute('maxlength', '18');

		input.addEventListener('focus', () => {
			if (!input.value) {
				input.value = '+7';
			}
		});

		input.addEventListener('input', () => {
			input.value = formatPhone(input.value);
		});

		input.addEventListener('paste', event => {
			event.preventDefault();

			const value =
				event.clipboardData?.getData('text/plain') ?? '';

			input.value = formatPhone(value);
		});

		input.addEventListener('blur', () => {
			const digits = normalizeDigits(input.value);

			if (digits.length <= 1) {
				input.value = '';
				return;
			}

			input.value = formatPhone(input.value);
		});
	});
};